module.exports = __webpack_public_path__ + "img/leiterinnen_julie-gisler.71696f95.png";